import React from 'react';
import { StyledTableRowColumn } from '../../table/StyledTable';
import { Currency } from 'ui-toolkit';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { StyledSelectedIcon, StyledTableRow } from './MatchedActualStyles';
import { IEscrowActualIncomingWireData } from 'types/accounting/data/IEscrowActualIncomingWireData';
import { getDateString } from '../../../../../ui-toolkit/utilities/getDateString';

interface IMatchActualWireDepositRowProps {
  wireDeposit: IEscrowActualIncomingWireData;
  selectedId?: string;
  setSelectedId: (detail: string | undefined) => void;
}

export const MatchActualWireDepositRow: React.FC<IMatchActualWireDepositRowProps> = ({
  wireDeposit,
  selectedId,
  setSelectedId,
}) => {
  return (
    <>
      <StyledTableRow
        columnsLength={6}
        onClick={() => {
          selectedId === wireDeposit.id ? setSelectedId(undefined) : setSelectedId(wireDeposit.id);
        }}
        data-test-id={'actual-wire-deposit-row'}
      >
        <StyledTableRowColumn>{getDateString(`LLLL d, yyyy`, wireDeposit.completedAtDate)}</StyledTableRowColumn>
        <StyledTableRowColumn>{wireDeposit.wireDetail.obi}</StyledTableRowColumn>
        <StyledTableRowColumn>{wireDeposit.wireDetail.org}</StyledTableRowColumn>
        <StyledTableRowColumn>
          <Currency value={wireDeposit.amountCents} valueIsCents />
        </StyledTableRowColumn>
        <StyledTableRowColumn>
          <Currency value={wireDeposit.wireDetail.amount_cents} valueIsCents />
        </StyledTableRowColumn>
        <StyledTableRowColumn>
          {selectedId === wireDeposit.id && (
            <StyledSelectedIcon icon={faCircleCheck} size={'lg'} aria-label={'selectedrow'} />
          )}
        </StyledTableRowColumn>
      </StyledTableRow>
    </>
  );
};
